import Link from 'next/link';
import ArrowRightLineIcon from 'remixicon-react/ArrowRightSLineIcon';

export type Breadcrumb = {
  label?: string;
  href?: string;
};

export type BreadcrumbProps = {
  breadCrumbs: Breadcrumb[];
};

export const Breadcrumbs = ({ ...props }: BreadcrumbProps) => {
  const breadcrumbsArray = props.breadCrumbs;
  if (breadcrumbsArray.at(-1)?.href) {
    throw new Error('Last breadcrumb should not have a link');
  }
  return (
    <div className="my-5 flex">
      {breadcrumbsArray.map((breadCrumb, idx) => {
        return (
          <div
            className={`text-title-7 flex items-center justify-center ${
              idx !== breadcrumbsArray.length - 1 ? 'font-medium ' : 'text-grey-600'
            }`}
            key={idx}
          >
            {breadCrumb.href ? (
              <Link href={breadCrumb.href} className={`cursor-pointer text-black underline`}>
                {breadCrumb.label}
              </Link>
            ) : (
              <div className="">{breadCrumb.label}</div>
            )}
            {idx !== breadcrumbsArray.length - 1 && (
              <div
                style={{
                  marginLeft: '4px',
                  marginRight: '4px',
                }}
              >
                <ArrowRightLineIcon size="16px" className="text-primary" />
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default Breadcrumbs;
